interface VigiaIconProps {
  size?: number
  className?: string
}

export function VigiaIcon({ size = 18, className = '' }: VigiaIconProps) {
  return <img src="/vigia-escudo-512px.png" alt="Vigía" width={size} height={size} className={className} />
}
